'use client';

import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

export function HomeFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      q: 'Pse është thelbësor instalimi me pompë vakuumi për kondicionerët dhe pompat?',
      a: 'Vakumimi heq plotësisht ajrin dhe lagështirën nga tubacionet e bakrit përpara hapjes së gazit ftohës (R32). Nëse nuk kryhet vakumim, lagështira krijon acid që dëmton vajin e kompresorit dhe shkakton djegie brenda 1-2 vitesh. Te DYRMA, çdo montim kryhet me vakummetër elektronik sipas specifikimeve të fabrikës.',
    },
    {
      q: 'Sa është garancia e pajisjeve të blera në DYRMA Climate?',
      a: 'Të gjitha pajisjet mbulohen me garanci zyrtare nga 3 deri në 5 vite (në varësi të markës dhe tipit të pajisjes). Gjithashtu, të gjitha pjesët origjinale të këmbimit dhe shërbimi teknik mbulohen nga stafi ynë i certifikuar.',
    },
    {
      q: 'Cili është avantazhi kryesor i Pompës së Nxehtësisë mbi ngrohjen me naftë apo gaz?',
      a: 'Pompat e nxehtësisë (Air-to-Water) funksionojnë me parimin e absorbimit të energjisë termike nga ajri i jashtëm. Për çdo 1 kW energji elektrike të konsumuar, ato gjenerojnë nga 4 deri në 5 kW energji termike (COP 4-5), duke ulur faturën mujore të ngrohjes deri në 65% krahasuar me ngrohjet tradicionale.',
    },
    {
      q: 'Si mund të marr një preventiv të detajuar për shtëpinë apo biznesin tim?',
      a: 'Mund të plotësoni formularin tonë online në "Kërko Preventiv", ose të na kontaktoni drejtpërdrejt në WhatsApp në +355 69 367 3867. Inxhinieri ynë mund të bëjë inspektim në vend dhe llogaritje të ngarkesës termike pa pagesë paraprake.',
    },
  ];

  return (
    <section className="py-16 px-4 sm:px-8 max-w-5xl mx-auto w-full">
      <div className="text-center mb-10 space-y-2">
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-sky-50 dark:bg-sky-950/60 text-sky-600 dark:text-sky-400 text-xs font-bold border border-sky-100 dark:border-sky-900">
          <HelpCircle className="w-3.5 h-3.5" />
          <span>Pyetjet më të Shpeshta</span>
        </div>
        <h2 className="text-2xl sm:text-3xl font-black text-slate-900 dark:text-white">
          Gjithçka që Duhet të Dini Rreth Zgjidhjeve Tona
        </h2>
        <p className="text-xs sm:text-sm text-slate-500 dark:text-slate-400">
          Përgjigje transparente nga inxhinierët termoteknikë të DYRMA Climate.
        </p>
      </div>

      <div className="space-y-3">
        {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div
              key={idx}
              className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 overflow-hidden transition-all"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : idx)}
                className="w-full flex items-center justify-between p-5 text-left font-bold text-sm sm:text-base text-slate-900 dark:text-white gap-4 hover:text-sky-600 dark:hover:text-sky-400 transition-colors"
              >
                <span>{faq.q}</span>
                <ChevronDown
                  className={`w-5 h-5 text-slate-400 transition-transform duration-200 flex-shrink-0 ${
                    isOpen ? 'rotate-180 text-sky-600' : ''
                  }`}
                />
              </button>

              {isOpen && (
                <div className="px-5 pb-5 text-xs sm:text-sm text-slate-600 dark:text-slate-300 leading-relaxed border-t border-slate-100 dark:border-slate-800 pt-3">
                  {faq.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
